import { render, staticRenderFns } from "./ManagerWidgets.vue?vue&type=template&id=046c8110&scoped=true"
import script from "./ManagerWidgets.vue?vue&type=script&lang=js"
export * from "./ManagerWidgets.vue?vue&type=script&lang=js"
import style0 from "./ManagerWidgets.vue?vue&type=style&index=0&id=046c8110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c8110",
  null
  
)

export default component.exports